import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classnames from "classnames";

import { changeLoginValue } from "../../redux/actions/index";

class LoginForm extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: ""
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {}

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }


  validateData = () => {
    let isFormValid = true;

    if (!this.validateField("username", "isUsernameValid")) {
      isFormValid = false;
    }

    if (!this.validateField("password", "isPasswordValid")) {
      isFormValid = false;
    }
    return isFormValid;
  };

  validateField = (field, isValidValue) => {
    let newState = {};
    let isValid = true;
    let missingString = field + "Missing";

    if (
      this.state[field] === "" ||
      this.state[field] === undefined ||
      this.state[field].length === 0
    ) {
      this.setState({ [missingString]: true });
      isValid = false;
    } else {
      this.setState({ [missingString]: "" });
    }

    newState[isValidValue] = isValid;
    this.setState(newState);
    return isValid;
  };

  onSubmit = async e => {
    e.preventDefault();

    let isFormValid = this.validateData();

    if (isFormValid) {

      try {

        let username = this.state.username;
        let password = this.state.password;

        const login = {
          username,
          password
        };

        const config = {
          headers: {
            "Content-Type": "application/json"
          }
        };

        const body = JSON.stringify(login);

        const res = await axios.post("api/auth", body, config);
        console.log(res);

        //change the state of the user in Redux
        this.props.ChangeUserState(true);

        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem("token", res.data.token);


        this.setState({isUsernameValid: true});
        this.setState({isPasswordValid: true});
        this.setState({loginFailed: false});

        this.context.router.history.push("/backoffice/pontos_interesse");
      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(1);
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
          this.setState({isUsernameValid: false});
          this.setState({isPasswordValid: false});
          this.setState({loginFailed: true});
          


        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(2);
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log(3);
          console.log("Error", error.message);
        }
      }
    }
  };

  renderMandatoryMessage = field => {
    if (this.state[field] === true) {
      return <span className="alert-danger ml-6">Campo obrigatório</span>;
    }
  };

  render() {

    return (
      <div className="col-4">
        <div className="">
          <img style={{width: '50%', marginBottom: '24px'}} src="/images/logo-marca.png" alt="" />
          <h1 className="reserved-area">Área Reservada</h1>

          <form className="form" onSubmit={e => this.onSubmit(e)}>
            {this.state.loginFailed &&
              <p className="alert-danger ml-6">Credenciais Inválidas</p>
            }
            
            <div className="form-group">
              <p className="labels">
                Nome{this.renderMandatoryMessage("usernameMissing")}
              </p>
              <input
                className={classnames(
                  "input-form",
                  this.state.isUsernameValid === false ? "bad-form" : ""
                )}
                type="text"
                name="username"
                value={this.state.username}
                placeholder="Username"
                onChange={this.handleChange}
              />
            </div>
            <div className="form-group">
            <p className="labels">
                Password{this.renderMandatoryMessage("passwordMissing")}
              </p>
              <input
                className={classnames(
                  "input-form",
                  this.state.isPasswordValid === false ? "bad-form" : ""
                )}
                type="password"
                name="password"
                value={this.state.password}
                placeholder="Password"
                onChange={this.handleChange}
              />
            </div>
            <input
              type="submit"
              className="backoffice-btn btn btn-outline-success"
              value="Login"
            />
          </form>

          {/*<p>{this.props.isLoggedIn ? 'true' : 'false'}</p>*/}
        </div>
      </div>
    );
  }
}

const mapStateToProps = store => ({
  isLoggedIn: store.updateLoginState.isLogged
});

const mapDispatchToProps = dispatch => {
  return {
    ChangeUserState: isLogged => dispatch(changeLoginValue(isLogged))
  };
};

export default 
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginForm);
